import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import HeaderComponent from '../Header/index';
import  DatePicker  from '../../screens/DatePicker';


class CreateAppointment extends Component {
  render() {
      return (
        <div>
          <HeaderComponent />
          <div>
            <div>
              <div><DatePicker history={this.props.history} /></div>
            </div>
          </div>
        </div>
      )
    }
}

function mapStateToProps(state) {
  const { users, auth } = state;
  const { user } = auth;
  return {
    user,
    users
  };
}

export default withRouter(connect(mapStateToProps)(CreateAppointment));


// WEBPACK FOOTER //
// ./src/components/CreateAppointment/index.js